
<template>
    <div class="el-Require">
        <el-row class="page_content">
            <h1 class="head_title">{{$getShowName()}}报名</h1>
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column prop="grade" header-align="center" align="center" label="等级">
                </el-table-column>

                <el-table-column prop="taskName" header-align="center" align="center" label="任务名称">
                </el-table-column>
                <el-table-column prop="professionalName" header-align="center" align="center" label="专业名称">
                </el-table-column>
                <el-table-column prop="adviserTeacherName" header-align="center" align="center" label="指导老师">
                </el-table-column>
                <el-table-column prop="title" header-align="center" align="center" width="150" label="操作">
                    <template slot-scope="scope">
                        <el-link :underline="false" type="primary" @click="openDetails(scope.row)">查看详情</el-link>
                        <el-link :underline="false" type="primary" @click="recordDataset(scope.row.thesisRecordId)">审批记录</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 10px;" background :page-size="limit" layout="prev, pager, next" :total="page"
                @current-change="handleCurrentChange">
            </el-pagination>
        </el-row>
        <!-- 查看详情弹框 -->
        <el-dialog title="详情" :visible.sync="detailsVisible" width="30%" >
            <el-row>
                <el-form ref="form" :model="deform" label-width="80px">
                <el-col :span="12">
                    <el-form-item label="等级">
                       {{deform.grade}}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="任务名称">
                        {{deform.taskName}}
                    </el-form-item>
                </el-col>
            </el-form>
            </el-row>
            <el-row>
                <el-form ref="form" :model="deform" label-width="80px">
                <el-col :span="12">
                    <el-form-item label="专业名称">
                       {{deform.professionalName}}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="指导老师">
                        {{deform.adviserTeacherName}}
                    </el-form-item>
                </el-col>
            </el-form>
            </el-row>
            <el-row>
                <el-form ref="form" :model="deform" label-width="80px">
                <el-col :span="12">
                    <el-form-item label="论文状态">
                       {{deform.thesisStatusText}}
                    </el-form-item>
                </el-col>
               
            </el-form>
            </el-row>
        </el-dialog>
        <!-- 查看详情弹框 -->
        <el-dialog title="审批记录" :visible.sync="recordDataVisible" width="50%" >
            <el-table :data="recordData" border style="width: 100%;" class="detailsTable">
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column prop="approveTime" header-align="center" align="center" label="审核时间">
                </el-table-column>
                <el-table-column prop="approveStatusText" header-align="center" align="center" label="审核状态">
                </el-table-column>
                <el-table-column prop="approveOpinion" header-align="center" align="center" label="审核意见" width="300">
                </el-table-column>
                <el-table-column prop="approveTeacherName" header-align="center" align="center" label="审核人">
                </el-table-column>
            </el-table>
            <div class="page"></div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "application",
    data() {
        return {
            count: 1,
            limit: 10,
            tableData: [],
            detailsVisible: false,
            recordDataVisible:false,
            deform:{},
            recordData:[]
        };
    },
    created() {

    },
    mounted() {
        this.page = 1
        this.getTable()
    },
    methods: {
        getTable() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let param = {
                limit: this.limit,
                page: this.page
            }
            this.$store.dispatch("thesis/getMyApplyList", param).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.tableData = ret.data
                    this.page = ret.count

                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        handleCurrentChange(val) {
            this.page = val
            this.getTable();
        },
        openDetails(row){
            this.detailsVisible=true
            this.deform={...row}
        },
        recordDataset(thesisRecordId){
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.recordDataVisible=true
            let param={
                thesisRecordId:thesisRecordId
            }
            this.$store.dispatch("thesis/getThesisCheckDetailByParam", param).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.recordData=ret.data.thesisApproveList
                    
                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        }
    }
};
</script>
<style  lang="less">
.page {
    height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/transactionPaper/application.vue